<!-- <i class="ri-information-line"	triggers="manual" [autoClose]="'outside'" (mouseenter)="hintTooltip.open();" ></i>
<ng-template #hintTooltip="ngbTooltip"  >
    Sample hint description
    <a href="www.abc.com" target="_blank" >Learn more</a>
</ng-template> -->

<i class="ri-information-line" [ngbTooltip]="hintContent" triggers="manual" #hintTooltip="ngbTooltip"
    [autoClose]="'outside'" (mouseenter)="openTooltip(hintTooltip)" (mouseleave)="delayedClosed(hintTooltip)">
</i>

<ng-template #hintContent>
    <span (mouseenter)="hoveringOverToolTip(hintTooltip,true)" (mouseleave)="hoveringOverToolTip(hintTooltip,false)">
        {{contentText}}
        <span *ngIf="link">
            <a  href="{{sanitizedLink}}" target="_self">{{linkText}}</a>
        </span>
    </span>
</ng-template>